import { LocalizationButton } from '@magicdoor/ui';

export const SignInTitle = (props: { title: string; subTitle: string }) => {
  return (
    <div class="mb-5 flex items-center justify-between">
      <h1 class="text-2xl font-semibold">
        <span>{props.title}</span>&nbsp;
        <span class="text-essential-colour">{props.subTitle}</span>
      </h1>
      <LocalizationButton />
    </div>
  );
};
